export const getConfigByMerchantCode = (merchantCode) =>{
    const config = merchantConfigs.find(c=>c.code===merchantCode);
    return config ? config : defaultConfig;
}

const defaultConfig={
    code:'CARBONCLICK',
    showHeader: true,
    offsetButtonText:"Offset your emissions"
}

const merchantConfigs=[
    {
        code:'BES_US_EARTHSHARE', 
        countryOverride:'US',
        showHeader: false,
        offsetAction:"IFRAME_POST_MESSAGE",
        offsetButtonText:"Save"
    },
    {
        code:'SHO_NZ_THE_GOOD_TONIC',
        showHeader: false
    }
]